window.I18n = require("i18n-js");

const translations = require("../locales.json");
I18n.translations = translations;
I18n.defaultLocale = "fr";
I18n.locale = I18n.defaultLocale;